import { env } from '../env';
export default {
  getNavigation: function getNavigation() {
    var _env$performance;

    return ((_env$performance = env().performance) == null ? void 0 : _env$performance.navigation) || {};
  },

  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var _env$performance2;

    return ((_env$performance2 = env().performance) == null ? void 0 : _env$performance2.getEntriesByType == null ? void 0 : _env$performance2.getEntriesByType('resource')) || [];
  },

  /**
   * get all loaded resources
   */
  getMarks: function getMarks() {
    var _env$performance3;

    return ((_env$performance3 = env().performance) == null ? void 0 : _env$performance3.getEntriesByType('mark')) || [];
  },
  getTiming: function getTiming() {
    var _env$performance4;

    return ((_env$performance4 = env().performance) == null ? void 0 : _env$performance4.timing) || {};
  },
  clearResourceTimings: function clearResourceTimings() {
    var _env$performance5;

    // eslint-disable-next-line no-unused-expressions
    (_env$performance5 = env().performance) == null ? void 0 : _env$performance5.clearResourceTimings == null ? void 0 : _env$performance5.clearResourceTimings();
  },

  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now: function now() {
    var _env$performance6, _performance;

    return ((_env$performance6 = env().performance) == null ? void 0 : _env$performance6.now == null ? void 0 : _env$performance6.now()) || typeof performance !== 'undefined' && ((_performance = performance) == null ? void 0 : _performance.now == null ? void 0 : _performance.now()) || new Date().getTime();
  },

  /**
   * Duration from fetch start to response end
   */
  responseEndTime: function responseEndTime() {
    var _performance2, _performance2$timing, _performance3, _performance3$timing;

    var fetchStart = (_performance2 = performance) == null ? void 0 : (_performance2$timing = _performance2.timing) == null ? void 0 : _performance2$timing.fetchStart;
    var responseEnd = (_performance3 = performance) == null ? void 0 : (_performance3$timing = _performance3.timing) == null ? void 0 : _performance3$timing.responseEnd;

    if (fetchStart && responseEnd) {
      return responseEnd - fetchStart;
    }
  },

  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    var _env$performance7;

    // eslint-disable-next-line no-unused-expressions
    (_env$performance7 = env().performance) == null ? void 0 : _env$performance7.mark == null ? void 0 : _env$performance7.mark(name);
  },

  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    var _env$performance8;

    // eslint-disable-next-line no-unused-expressions
    (_env$performance8 = env().performance) == null ? void 0 : _env$performance8.measure == null ? void 0 : _env$performance8.measure(name, startMark, endMark);
  },

  /**
   * Get performance entries by name
   */
  getEntriesByName: function getEntriesByName(name) {
    var _env$performance9;

    return ((_env$performance9 = env().performance) == null ? void 0 : _env$performance9.getEntriesByName == null ? void 0 : _env$performance9.getEntriesByName(name)) || [];
  }
};